module.exports = __webpack_public_path__ + "assets/img/car08.cb189cfd.jpg";